export default "__VITE_ASSET__Cdg9fhjT__"